import React from "react";
import { DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Stack, FormControl, RadioGroup, FormControlLabel, FormLabel, Radio, Divider, FormGroup, Checkbox} from "@mui/material";
import { D, C } from "../include";



export class Survey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_id: this.props.patient_id ? this.props.patient_id : -1, 
      procedure_id: this.props.procedure_id ? this.props.procedure_id : -1,
      questionnaire_id: this.props.questionnaire_id ? this.props.questionnaire_id : -1,
      company_id: this.props.company_id ? this.props.company_id : -1,
      type: this.props.document_type ? this.props.document_type : -1,
      edit: false,
      survey: null,
      
    };
  }
  
  
  componentDidMount() {
    this.setState({ loading: true });
    this.props.api
      .get('/Survey/' + this.state.procedure_id + '/' + this.state.questionnaire_id)
      .then((r) => {  
        this.setState({
          loading: false,
          edit: r.previouslyAnswered,
          survey: r.survey,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }


  handleSubmit = (event) => {
    event.preventDefault();
    this.props.dialogClose();
    
    var answers = []
    for(let s in this.state.survey){
      let item = []
      item.push(this.state.survey[s].question_id);
      item.push(this.state.survey[s].user_selection);
      item.push(this.state.survey[s].user_complement);
      answers.push(item);
    }
   
    if (!this.state.edit) {
      this.props.api
        .post('/Answers', { company_id: this.state.company_id, type: this.state.type, procedure_id: this.state.procedure_id, questionnaire_id: this.state.questionnaire_id, answers: answers })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Procedimento criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro')); 
    } else {
      this.props.api
        .put('/Answers', { company_id: this.state.company_id, type: this.state.type, procedure_id: this.state.procedure_id, questionnaire_id: this.state.questionnaire_id, answers: answers })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações')); 
    }
  };


  handleChangeInQuestion = (survey_index,question_id, type, user_complement, user_selection) => {
      if(this.state.survey[survey_index].question_id === question_id){
        var s = this.state.survey;
        s[survey_index].user_selection = (user_selection ? user_selection : []);
        s[survey_index].user_complement = (user_complement ? user_complement : null);
        this.setState({survey: s});
      }
  }
 
  
  render() {
    return (
      <form onSubmit={(event) => this.handleSubmit(event)} method="GET">
        <input type="hidden" name="r" value={this.state.patient_id} /> 
        
        <DialogTitle style={{ minWidth: '400px' }}>
          {C.DocumentType[this.state.type]}
        </DialogTitle>
        <DialogContent>        
          <Stack>
          {          
            this.state.survey && this.state.survey.map( (s,index) => {
              return(
                  <D key={s.question_id}>                
                  {(s.type === 1) &&
                    <QuestionRadioButton                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                      horizontal={true}
                    />
                  }
                  {(s.type === 2) &&
                    <QuestionSlidebar                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                    />
                  }
                  {(s.type === 3) &&
                    <QuestionCheckbox                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                    />
                  }
                  {(s.type === 4) &&
                    <QuestionEditbox                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                      horizontal={false}
                    />
                  } 
                  <D h="1rem" /><Divider/><D h="1rem" />
                </D>
              );
            }) 
          }
          </Stack>
          
          <D h="1rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" type="button" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

























export class QuestionRadioButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question_id: this.props.question_id ? this.props.question_id : -1,
      type: this.props.type ? this.props.type : -1,
      label: this.props.label ? this.props.label : "Uma pergunta",
      label_asking_complement: this.props.label_asking_complement ? this.props.label_asking_complement : null, 
      user_complement: this.props.user_complement ? this.props.user_complement : null, 
      user_selection: this.props.user_selection ? this.props.user_selection : [],
      choice: this.props.choice ? this.props.choice : null,
      horizontal: this.props.horizontal ? this.props.horizontal : false,      
    };
  }


  handleChangeRadio = (value) => {
    this.setState({user_selection: [parseInt(value)]});
    this.props.onChange(this.props.survey_index,this.state.question_id,this.state.type,this.state.user_complement,[parseInt(value)])
  }
  
  handleChangeTextField = (value) => {
    this.setState({user_complement: value});
    this.props.onChange(this.props.survey_index,this.state.question_id,this.state.type,value,this.state.user_selection)
  }
  
  
  render() {
    return (
      <FormControl fullWidth>
        <FormLabel id={this.props.question_id}><strong>{this.state.label}</strong></FormLabel>
        <RadioGroup
          value={(this.state.user_selection.length===1 ? this.state.user_selection[0] : null)}
          row={this.state.horizontal}
          onChange={(e) => this.handleChangeRadio(e.target.value)}
        >
          {
          this.state.choice.map( c => {
              return(<FormControlLabel key={c.choice_id} value={c.choice_id} control={<Radio required/>} label={c.choicelabel} />)
          })
          }
        </RadioGroup>
        {this.state.label_asking_complement &&
          <Stack direction="row" spacing={1}>
            <Typography>{this.state.label_asking_complement}</Typography>
            <TextField
                variant="outlined"
                value={this.state.user_complement ? this.state.user_complement : ""}
                onChange={(e) => this.handleChangeTextField(e.target.value)}
                size="small"
                fullWidth
            />
          </Stack>
        }
      </FormControl>           
    );
  }
}






export class QuestionSlidebar extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      question_id: this.props.question_id ? this.props.question_id : -1,
      type: this.props.type ? this.props.type : -1,
      label: this.props.label ? this.props.label : "Uma pergunta",
      label_asking_complement: this.props.label_asking_complement ? this.props.label_asking_complement : null, 
      user_complement: this.props.user_complement ? this.props.user_complement : null, 
      user_selection: this.props.user_selection ? this.props.user_selection : [],
      choice: this.props.choice ? this.props.choice : null,  
      survey_index: this.props.survey_index ? this.props.survey_index : -1,   
    };
    //onChange must provide these parameters: question_id, type, user_complement, choice_id, user_selected
  }


  render() {
    return (
      <Typography>Slidebar TODO: <strong>{this.state.label}</strong></Typography>
    );
  }
}







export class QuestionCheckbox extends React.Component {
  constructor(props) {
    super(props);
    
    var user_selection_dic = {};
    if(this.props.choice && this.props.user_selection){
      for(let i in this.props.choice){
        user_selection_dic[this.props.choice[i]] = ((this.props.choice[i] in this.props.user_selection) ? true : false)
      }
    }
    
    this.state = {
      question_id: this.props.question_id ? this.props.question_id : -1,
      type: this.props.type ? this.props.type : -1,
      label: this.props.label ? this.props.label : "Uma pergunta",
      label_asking_complement: this.props.label_asking_complement ? this.props.label_asking_complement : null, 
      user_complement: this.props.user_complement ? this.props.user_complement : null, 
      user_selection: this.props.user_selection ? this.props.user_selection : [],
      choice: this.props.choice ? this.props.choice : null,
      horizontal: this.props.horizontal ? this.props.horizontal : false,  
      user_selection_dic: user_selection_dic,    
    };
  }


  handleChangeCheck = (e) => {
    var user_selection_dic = this.state.user_selection_dic;
    user_selection_dic[e.target.name] = e.target.checked;
    
    var user_selection = [];
    for(let i in user_selection_dic)
      if(user_selection_dic[i])
        user_selection.push(e.target.name);
    
    this.setState({user_selection: user_selection, user_selection_dic: user_selection_dic});
    this.props.onChange(this.props.survey_index,this.state.question_id,this.state.type,this.state.user_complement,user_selection)
  }
  
  
  render() {   
    return (
      <FormControl fullWidth>
        <FormLabel id={this.props.question_id}><strong>{this.state.label}</strong></FormLabel>
        <FormGroup
          row={this.state.horizontal}
        >
          {
          this.state.choice.map( c => {
              return(<FormControlLabel key={c.choice_id} control={<Checkbox name={c.choice_id} checked={this.state.user_selection_dic[c.choice_id]} onChange={(e) => this.handleChangeCheck(e)}/>} label={c.choicelabel} />)
          })
          }
        </FormGroup>
      </FormControl>           
    );
  }
}







export class QuestionEditbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question_id: this.props.question_id ? this.props.question_id : -1,
      type: this.props.type ? this.props.type : -1,
      label: this.props.label ? this.props.label : "Uma pergunta",
      label_asking_complement: this.props.label_asking_complement ? this.props.label_asking_complement : null, 
      user_complement: this.props.user_complement ? this.props.user_complement : null, 
      user_selection: this.props.user_selection ? this.props.user_selection : [],
      choice: this.props.choice ? this.props.choice : null,  
      survey_index: this.props.survey_index ? this.props.survey_index : -1,    
    };
    //onChange must provide these parameters: question_id, type, user_complement, choice_id, user_selected
  }


  handleChangeTextField = (value) => {
    this.setState({user_complement: value});
    this.props.onChange(this.props.survey_index,this.state.question_id,this.state.type,value,this.state.user_selection)
  }
  
  
  render() {
    return (
      <FormControl fullWidth>
        <FormLabel id={this.props.question_id}><strong>{this.state.label}</strong></FormLabel>
        <TextField
            variant="outlined"
            value={this.state.user_complement ? this.state.user_complement : ""}
            onChange={(e) => this.handleChangeTextField(e.target.value)}
            size="small"
            fullWidth
            required
        />
      </FormControl> 
    );
  }
}
